import type { CSSProperties } from "react";

type AmbientGlowProps = {
  /** Kolor poświaty - domyślnie acid green z brand systemu */
  color?: string;
  /** Rozmiar w px, promień radialnego gradientu */
  size?: number;
  className?: string;
  style?: CSSProperties;
};

/**
 * Umieść wewnątrz sekcji z `position: relative`, jako pierwsze dziecko.
 * Element jest absolutny, wycentrowany, nie wpływa na layout ani przepływ treści.
 * Nie wymaga żadnego JS - czysty statyczny CSS, tani w renderowaniu.
 *
 * Przykład:
 *   <section id="advantage" className="relative">
 *     <AmbientGlow />
 *     ...istniejąca treść sekcji, bez zmian...
 *   </section>
 */
export function AmbientGlow({ color = "190, 242, 100", size = 640, className, style }: AmbientGlowProps) {
  return (
    <div
      aria-hidden="true"
      className={className}
      style={{
        position: "absolute",
        top: 0,
        left: "50%",
        width: size,
        height: size,
        transform: "translate(-50%, -35%)",
        background: `radial-gradient(circle, rgba(${color}, 0.06) 0%, rgba(${color}, 0) 70%)`,
        filter: "blur(60px)",
        pointerEvents: "none",
        zIndex: 0,
        ...style,
      }}
    />
  );
}
